export default "__VITE_ASSET__BrU7ZNIT__"